import React from 'react';
import ErrorMobile from './ErrorMobile.svg';

const Icon = props => <ErrorMobile {...props} />;

export default Icon;
